import { render } from "./PayHref.vue?vue&type=template&id=5383fa96"
import script from "./PayHref.vue?vue&type=script&lang=js"
export * from "./PayHref.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__